// extracted by mini-css-extract-plugin
export default {"label":"SectionLabel_label__5y1Y0","link":"SectionLabel_link__-hBbM"};